/** Favicon Studeva servi par `index.html`, repris dès qu'une org n'en a pas. */
const DEFAULT_FAVICON = { href: '/favicon.png', type: 'image/png' }

/**
 * Type MIME porté par un data-URI (`data:image/svg+xml;base64,…`). Le tag
 * d'`index.html` annonce `image/png` : le garder tel quel mentirait sur un
 * favicon SVG ou ICO uploadé (#15).
 */
function dataUriType(href: string): string | null {
  return /^data:([^;,]+)[;,]/.exec(href)?.[1] ?? null
}

/**
 * Met à jour le <link rel="icon"> (crée le tag s'il n'existe pas).
 *
 * Un favicon vide **restaure** celui de Studeva plutôt que de ne rien faire :
 * en navigation SPA, le tag survit au changement d'organisation, donc sortir
 * sans rien écrire laissait l'icône de l'org précédente sur une org qui n'en
 * définit aucune (#15).
 */
export function applyFavicon(href?: string | null) {
  let link = document.querySelector<HTMLLinkElement>('link[rel="icon"]')
  if (!link) {
    link = document.createElement('link')
    link.rel = 'icon'
    document.head.appendChild(link)
  }

  const next = href || DEFAULT_FAVICON.href
  const type = href ? dataUriType(href) : DEFAULT_FAVICON.type
  if (type) link.type = type
  else link.removeAttribute('type')
  link.href = next
}
